import React from 'react';
import { Link as AnchorLink } from 'react-scroll';
import { Link } from 'gatsby';

// Accepts a "to" prop that can be a hash, query, or path
function NavLink({ children, offset, to, onClick }) {
  // Use AnchorLink if the "to" prop is a hash (in-page scroll)
  const isHash = to && to.startsWith('#');

  const anchorLinkProps = {
    activeClass: 'current',
    spy: true,
    smooth: true,
    duration: 1000,
    offset: offset ?? -78,
    onClick,
  };

  // Use AnchorLink for hashes, Gatsby Link otherwise
  return isHash ? (
    <AnchorLink {...anchorLinkProps} to={to.slice(1)}>
      {children}
    </AnchorLink>
  ) : (
    <Link to={to} onClick={onClick}>
      {children}
    </Link>
  );
}

export default NavLink;
